export default {
    methods: {
        initFilter (res, key, alias) {
            let {
                accountName,
                appList,
                displayName,
                gameIdKey,
                gameName,
                languageList,
                platformList,
                sectionList,
                contactUsGameList,
                appName,
                gameId
            } = res;
            console.log(res);
            platformList = this.getPlatformList(platformList)
            let platform = platformList[0] ? platformList[0].text : undefined;
            let page = this.$route.params.page
            page = page.toLowerCase()
            // this.$route.params.gameName = displayName;
            // let title = displayName || accountName;
            let title = page == 'account' ? accountName : displayName
            appList = this.dealAppList(appList)
            let allOptions = {
                platform,
                title,
                languageList,
                language: alias,
                appList,
                platformList,
                gameIdKey,
                key,
                contactUsGameList,
                appName,
                gameId
            };
            this.$emit("init-options", allOptions);
            this.sectionList = sectionList;
        },
        getPlatformList (platformList) {
            let platform = JSON.parse(JSON.stringify(platformList))
            platform.forEach(item => {
                if (item.value == '') {
                    // item.text = '所有平台'
                    item.text = this.$t('component.filters.allPlatform')
                }
            })
            return platform
        },
        dealAppList (list) {
            return list.map(item => {
                item.showName = item.showName || item.gameName
                return item
            })
        }
    },
}